import { isDefined, Option, Terminator } from "@opendaw/lib-std";
import { AudioEffectCompositeCellBoxAdapter, InstrumentCompositeCellBoxAdapter, PlayfieldSampleBoxAdapter } from "@opendaw/studio-adapters";
export class NestedHostExit {
    static targetsOf(host) {
        return host.deviceHost().asCompositeCell().match({
            none: () => [host.audioUnitBoxAdapter().box.editing],
            some: parent => [parent.box, ...NestedHostExit.targetsOf(parent)]
        });
    }
    #terminator;
    #watching;
    constructor(boxAdapters, userEditing) {
        this.#terminator = new Terminator();
        this.#watching = this.#terminator.own(new Terminator());
        this.#terminator.own(userEditing.catchupAndSubscribe(option => {
            this.#watching.terminate();
            option.flatMap(vertex => this.#nestedHost(boxAdapters, vertex.box)).ifSome(host => {
                const targets = NestedHostExit.targetsOf(host);
                // a remote delete or an undo takes the box away mid-transaction, the pointer is rewritten after it
                this.#watching.own(host.box.subscribeDeletion(() => queueMicrotask(() => {
                    if (userEditing.get().nonEmpty()) {
                        return;
                    }
                    const survivor = targets.find(target => target.box.isAttached());
                    if (isDefined(survivor)) {
                        userEditing.edit(survivor);
                    }
                })));
            });
        }));
    }
    terminate() { this.#terminator.terminate(); }
    #nestedHost(boxAdapters, box) {
        return Option.wrap(box.accept({
            visitInstrumentCompositeCellBox: (box) => boxAdapters.adapterFor(box, InstrumentCompositeCellBoxAdapter),
            visitAudioEffectCompositeCellBox: (box) => boxAdapters.adapterFor(box, AudioEffectCompositeCellBoxAdapter),
            visitPlayfieldSampleBox: (box) => boxAdapters.adapterFor(box, PlayfieldSampleBoxAdapter)
        }));
    }
}
